import { INotAvailableModal } from '../../types/notAvailableModal';
import { IApplicationState } from '../../types/redux';

export const selectNotAvailableModal = (state: IApplicationState): INotAvailableModal => state.notAvailableModal;
